import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Check } from "lucide-react";
 * // Use <Check /> instead
 */
export const CheckboxIcon = createSVGWrapper(
  <path
    clipRule="evenodd"
    d="m5 4a1 1 0 0 0 -1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-14a1 1 0 0 0 -1-1zm11.728 5.685a1 1 0 0 0 -1.456-1.37l-4.92 5.226-1.624-1.726a1 1 0 0 0 -1.456 1.37l2.353 2.5a1 1 0 0 0 1.456 0z"
    fill="currentColor"
    fillRule="evenodd"
  />
);
